module.exports = ".project-role-jwt-tokens__hide-token {\n  position: absolute;\n  right: 1em;\n  top: 1em;\n  cursor: pointer; }\n"